import React from 'react';
import { Box, TextField, Typography, useTheme } from '@mui/material';
import Dialog, { DialogProps } from '../../common/components/dialog/Dialog';
import { boxCss, cardCss, descriptionCss } from '../../common/style';
import { px2rem } from '../../core';

export interface ImageSettingModalProps extends DialogProps {
    idx: number;
    url: string;
    caption: string;
    handleChangeImageCaption: (cap: string, idx: number) => void;
}

const ImageSettingModal: React.FC<ImageSettingModalProps> = ({
    idx,
    url,
    caption,
    handleChangeImageCaption,
    ...props
}) => {
    const theme = useTheme();
    return (
        <>
            <Dialog title={`Edit Image`} showClose {...props}>
                <Box sx={{ padding: `${px2rem(12)} ${px2rem(28)} ${px2rem(50)}` }}>
                    <Box sx={boxCss(theme)}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: `${px2rem(10)}`,
                            }}
                        >
                            <img
                                src={url}
                                css={{
                                    objectFit: 'contain',
                                    height: 300,
                                }}
                            />
                        </Box>
                        <Box css={cardCss()}>
                            <Typography sx={descriptionCss(theme)}>Image Caption</Typography>
                        </Box>
                        <TextField
                            sx={{ marginTop: px2rem(12) }}
                            value={caption}
                            fullWidth={true}
                            multiline
                            minRows={1}
                            inputProps={{ maxLength: 200 }}
                            onChange={(e) => handleChangeImageCaption(e.target.value, idx)}
                        />
                    </Box>
                </Box>
            </Dialog>
        </>
    );
};
export default ImageSettingModal;
